import React from 'react';
import food from '../images/plans/food.png';
import office from '../images/plans/office.png';
import retails from '../images/plans/retails.png';

const list = [
  {
    img: office,
    title: "Office Space",
    head: "Innovative Spaces for Progressive Businesses",
    text: "Discover office spaces tailored for modern entrepreneurs, start-ups, and established corporations. With state-of-the-art infrastructure, flexible layouts, and a professional atmosphere, our offices are designed to inspire productivity and success.",
    features: [
      "Flexible office layouts",
      "High-speed internet and power backup",
      "Ample parking space",
      "Premium business environment",
    ],
  },
  {
    img: retails,
    title: "Retail Showrooms",
    head: "The Perfect Space for Your Brand to Shine",
    text: "At Homeland Commercial, we offer premium retail showrooms that ensure your business stands out. Whether you're launching a new venture or expanding your retail presence, our strategically located showrooms are crafted to attract high foot traffic and maximize visibility.",
    features: [
      "Prime location for maximum visibility",
      "Modern, customizable interiors",
      "High footfall area",
      "Ideal for luxury and lifestyle brands",
    ],
  },
  {
    img: food,
    title: "Food Court",
    head: "Where Culinary Delights Meet a Lively Atmosphere",
    text: "Our vibrant food court is the perfect hub for food entrepreneurs and established culinary brands. Designed to attract food enthusiasts and provide an inviting dining experience, it’s the ideal spot for growing your restaurant or food business.",
    features: [
      "Spacious and well-designed seating area",
      "A mix of local and international cuisine options",
      "High foot traffic from office and retail visitors",
      "Modern facilities with excellent amenities",
    ],
  }
  // Add more items to the list as needed
];

const Homeplan = () => {
  return (
    <div className="m-4 sm:m-8 md:m-12 lg:m-16 border-[1px] border-gray-100 shadow-md">
      <div className="flex flex-col items-center">
        {/* Heading */}
        <div className="heading flex flex-col w-full items-center justify-center gap-5 px-4 sm:px-8 lg:px-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl p-2">
            Your Gateway to Premium Business Opportunities
          </h2>
          <div className="h-2 w-[22%] sm:w-[25%] border-b-[1px] border-black"></div>
        </div>

        {/* Paragraph */}
        <div className="paragraph">
          <p className="text-base sm:text-lg md:text-xl text-center p-8">
            At Homeland Commercial, we bring you an exceptional platform to
            thrive in the heart of the city. Our commercial project is designed
            to cater to businesses of all types, providing you with world-class
            facilities and a vibrant business environment. Here's what we
            offer:
          </p>
        </div>
      </div>

      {/* Plans Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 p-8">
        {list.map((item, ind) => (
          <div
            key={ind}
            className="border rounded-lg shadow-md p-6 flex flex-col items-center"
          >
            <div className="image mb-4">
              <img src={item.img} alt={item.title} className="" />
            </div>
            <div className="details text-center">
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <p className="text-lg mb-2">{item.head}</p>
              <p className="text-base text-gray-600 mb-4">{item.text}</p>
              <ul className="list-disc list-inside text-left">
                {item.features.map((feature, featureInd) => (
                  <li key={featureInd}>{feature}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Homeplan;
